var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSwitchOrderInactive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.29289 1.10028e-06C6.5581 1.14665e-06 6.81246 0.105358 6.99999 0.292895L12.2071 5.87868C12.5976 6.2692 12.5976 6.90237 12.2071 7.29289C11.8166 7.68342 11.1834 7.68342 10.7929 7.29289L7.29288 3.41421L7.29288 19C7.29288 19.5523 6.84517 20 6.29288 20C5.7406 20 5.29288 19.5523 5.29288 19L5.29288 3.41421L1.70711 7.29289C1.31658 7.68342 0.683416 7.68342 0.292892 7.29289C-0.0976323 6.90237 -0.0976322 6.2692 0.292892 5.87868L5.58578 0.292894C5.77331 0.105358 6.02767 1.05391e-06 6.29289 1.10028e-06Z",
    fill: "#D1D7E0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.7071 23C16.4419 23 16.1875 22.8946 16 22.7071L10.7929 17.1213C10.4024 16.7308 10.4024 16.0976 10.7929 15.7071C11.1834 15.3166 11.8166 15.3166 12.2071 15.7071L15.7071 19.5858L15.7071 4C15.7071 3.44771 16.1548 3 16.7071 3C17.2594 3 17.7071 3.44772 17.7071 4L17.7071 19.5858L21.2929 15.7071C21.6834 15.3166 22.3166 15.3166 22.7071 15.7071C23.0976 16.0976 23.0976 16.7308 22.7071 17.1213L17.4142 22.7071C17.2267 22.8946 16.9723 23 16.7071 23Z",
    fill: "#D1D7E0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwitchOrderInactive);
export default __webpack_public_path__ + "static/media/switch-order-inactive.9b6b2e0d.svg";
export { ForwardRef as ReactComponent };